export default {
  namespaced:true,
  state : {  
    items:[],
  },
  mutations : { 
    MUTATION_EXTERNALGAME (state,data) { 
      state.items = data 
    }
  },
  getters : { 
    GETTERS_EXTERNALGAME :state=>state.items, 
  }
} 